import constants from "./constants.js"
import authHeader from "./auth.header.js"

const HOST_URL = constants.API_URL

async function readError(response) {
    const body = await response.text()
    if (!body) return `La recherche a echoue (${response.status}).`

    try {
        const payload = JSON.parse(body)
        return payload.message || payload.error || JSON.stringify(payload.errorList || payload)
    } catch (error) {
        return body
    }
}

export async function getSerperActivation() {
    const response = await fetch(`${HOST_URL}/options/activate_serper`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            ...authHeader(),
        },
    })

    if (!response.ok) {
        throw new Error(`Impossible de lire l'option Serper (${response.status}).`)
    }

    const payload = await response.json()
    const value = typeof payload === "object" && payload !== null
        ? payload.value ?? payload.activate_serper
        : payload

    if (value !== 0 && value !== 1 && value !== "0" && value !== "1") {
        throw new Error("La valeur de l'option activate_serper est invalide.")
    }

    return Number(value) === 1
}

export async function searchWithSerper({ q, country, links, page, delay }) {
    const response = await fetch(`${HOST_URL}/search`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...authHeader(),
        },
        body: JSON.stringify({ q, country, links, page, delay }),
    })

    if (response.status === 401) {
        throw new Error("Connectez-vous pour utiliser la recherche.")
    }

    if (!response.ok) {
        const error = new Error(await readError(response))
        error.status = response.status
        throw error
    }

    return response.json()
}

export async function getSerperQuota() {
    const response = await fetch(`${HOST_URL}/search/quota`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            ...authHeader(),
        },
    })

    if (!response.ok) {
        throw new Error(`Impossible de lire le quota de recherche (${response.status}).`)
    }

    return response.json()
}
